import { TextField } from '@mui/material';
import MaskedInput from 'react-text-mask';
import { useTranslation } from "react-i18next";

const MaskedInputWrapper = ({ 
    name, 
    placeholder,
    value, 
    label, 
    onChange, 
    maskType, 
    mask,
    error, 
    theme, 
    required,
    InputProps,
    onBlur,
}) => {

    const { t } = useTranslation();

    const masks = {
        phone: ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        twoNumbers: [/[0-9]/, /\d/],
        fourNumbers: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
        creditCardExpiryDate: [/[0-1]/, /\d/, '/', /[0-9]/, /\d/],
    }

    const finalMask = mask || (maskType && masks[maskType]);

    return(
        <MaskedInput
            mask={finalMask}
            placeholder={placeholder}
            className="form-control"
            guide={false}
            id={name}
            onChange={onChange}
            render={(ref, props) => (
                <TextField 
                    fullWidth 
                    {...label && { label }}
                    inputRef={ref} {...props} 
                    value={value}
                    variant="outlined"
                    {...error && {helperText: t(error), error: true}}
                    required={required}
                    sx={{ ...(theme && theme.typography.customInput) }} 
                    InputProps={InputProps}
                    onBlur={onBlur}
                />
            )}
        />
    )

}

export default MaskedInputWrapper;